import { httpApi } from '@app/api/http.api'

export type AcceptConsentPayload = {
  rodoPolicyDocumentId?: string
  dataProcessingConsentId?: string
}

export type UserConsentResponse = {
  id: string
  acceptedAt: string
  revokedAt: string | null
  rodoPolicyDocument: {
    documentationFile: { content: string; name: string; type: string }
  }
  dataProcessingConsent: {
    documentationFile: { content: string; name: string; type: string }
  }
  user: {
    id: string
    email: string
    firms: { name: string }[]
    firstName: string
    lastName: string
  }
}
const CONSENTS = 'consents'

export const checkMyConsentExists = (): Promise<boolean> =>
  httpApi.get<boolean>(`${CONSENTS}/me/exists`).then(({ data }) => data)

export const acceptConsent = (payload: AcceptConsentPayload) =>
  httpApi.post(`${CONSENTS}/accept`, payload).then(({ data }) => data)

export const revokeConsent = (consentId: string) =>
  httpApi.post(`${CONSENTS}/revoke/${consentId}`).then(({ data }) => data)

export const getAllUsersConsents = (): Promise<UserConsentResponse[]> =>
  httpApi.get<UserConsentResponse[]>(`${CONSENTS}/all`).then(({ data }) => data)
